import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useUserStore } from '../../stores/userStore';

import { SearchSessionProvider } from './SearchSessionContext';

const SearchEditingContext = createContext(null);
// Keep the draft while a detail route is open, but never show another route/account's draft.
export function SearchEditingProvider({ children }) {
  const { pathname, search } = useLocation();
  const scope = String(useUserStore((s) => s.user?.id) ?? 'guest');
  const route = pathname + search;
  const [draft, setDraft] = useState(null);
  if (draft && draft.scope !== scope) setDraft(null);
  useEffect(
    () =>
      useUserStore.subscribe?.((state, previous) => {
        if (state.user?.id !== previous.user?.id) setDraft(null);
      }),
    [],
  );
  const active = draft?.route === route && draft?.scope === scope;
  return (
    <SearchSessionProvider>
      <SearchEditingContext.Provider
        value={{
          active,
          text: active ? draft.text : '',
          composing: active ? draft.composing : false,
          edit: (text, composing = false) => setDraft({ route, scope, text, composing }),
          close: () => setDraft(null),
        }}
      >
        {children}
      </SearchEditingContext.Provider>
    </SearchSessionProvider>
  );
}
export const useSearchEditing = () => useContext(SearchEditingContext);
